module.exports = __webpack_public_path__ + "static/media/workplace_wellness_hero.9bf1634f.png";